import { clearHtmlTags } from '@shared/utils/utils';
import { AnchorList } from '../const/anchor-list';

export class HelixBookUtils {
  static getItemSubjects(searchValue: string): string[] {
    const searchHeaderRegex = new RegExp('<strong.*>.*</strong>', 'g');
    const matches =
      searchValue
        .match(searchHeaderRegex)
        ?.map((match) => clearHtmlTags(match))
        ?.filter((match) => AnchorList.includes(match)) ?? [];

    return matches;
  }
}
